import { useElapsed, colorState, fmtTimer, STATE_COLORS } from "@/lib/time";

export function LiveTimer({ startIso, sla, size = "text-4xl", testId }) {
  const seconds = useElapsed(startIso);
  const state = colorState(seconds, sla);
  const color = STATE_COLORS[state];
  const overdue = state === "red" || state === "darkred";
  let overdueBy = null;
  if (overdue && sla) overdueBy = seconds - sla.overdue_minutes * 60;
  return (
    <div className="flex flex-col">
      <span
        className={`font-mono-t font-bold leading-none ${size}`}
        style={{ color }}
        data-testid={testId}
      >
        {fmtTimer(seconds)}
      </span>
      {overdue && overdueBy != null && (
        <span className="font-mono-t text-[10px] mt-1" style={{ color }}>
          OVERDUE +{fmtTimer(overdueBy)}
        </span>
      )}
    </div>
  );
}

export default LiveTimer;
